var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-body",style:(`background-image:url(${_vm.banner}); background-repeat: no-repeat; background-size: cover`)},[_c('div',{staticClass:"header-body__logo"},[_c('img',{attrs:{"src":_vm.logo,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }